<template>
    <v-slide-y-transition>

        <v-row class="text-center h-60-vh align-center">
            <v-col>
                <v-progress-circular
                    indeterminate
                    color="primary"
                    class="mr-3"
                ></v-progress-circular>
                <span class="body-2" v-text="text"></span>
            </v-col>
        </v-row>

    </v-slide-y-transition>

</template>
<script>

import Snackbar from "@/components/Snackbar.vue";
import {useVuetify} from "@/composables/vuetify";
import {computed, toRef, ref, toRefs} from "vue";
import MixinIcon from "@/mixins/MixinIcon";

export default {
    name: 'ListingLoading',
    components: {
        Snackbar
    },
    props: {
        text: {
            type: String,
            required: true,
            // default: 'Loading...' // We want to receive this via processed $gettext, hence don't use this
        }
    },
    setup(props, context) {

        const vuetify = useVuetify();
        let isDark = computed(() => {
            return vuetify.theme.dark
        })
        const icons = MixinIcon.data().icons

        // props of item, and green
        const {text} = toRefs(props)

        return {
            icons,
            isDark,
            text
        }

    }

}

</script>
<style>

.h-60-vh {
    height: 60vh;
}
</style>
